<template>
  <div class="login-wrap">
    <el-form
      v-loading="loading"
      label-position="top"
      :rules="rules"
      ref="ruleForm"
      :model="formData"
      label-width="80px"
    >
      <h2>用户登录</h2>
      <el-form-item label="用户名" prop="username">
        <el-input v-model="formData.username"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          type="password"
          v-model="formData.password"
          @keyup.enter.native="login"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="login-btn" type="primary" @click="login">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      formData: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: '密码长度大于 6 个字符', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    login() {
      let that = this;
      // 表单验证
      that.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return false;
        }
        that.loading = true;
        that.$axios
          .post(that.host + "/api/users/login", this.formData)
          .then((res) => {
            let results = res.data.results;
            let token = results.token;
            let user_id = results.user_id;
            let username = results.username;
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("username", username);
            sessionStorage.setItem("user_id", user_id);
            that.loading = false;
            that.$router.push("/home");
          })
          .catch((err) => {
            that.$message.error(err.data.errmsg);
            that.loading = false;
          });
      });
    },
  },
};
</script>

<style>
body,
html {
  height: 100%;
  margin: 0;
}
.login-wrap {
  background-image: url("../assets/img/login-bg.jpg");
  background-size: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-form.el-form--label-top {
  padding: 40px;
  width: 500px;
  border-radius: 5px;
  background-color: #fff;
}
.el-form .login-btn {
  width: 100%;
}
</style>
